import React, { useState } from "react"
import { Button, Card, Modal } from "components/common"
import { toast } from "react-toastify";
import AsyncSelect from 'react-select/async';
import { useDispatch } from "react-redux";
import { assignContact } from "redux/crm/customerSlice";
import { salesEmployeesByNameDebounce } from "helpers/employeeOptionHelper";
import { FaBan, FaUser } from "react-icons/fa";
import PropTypes from 'prop-types';

const AssignCustomerModal = ({showModal, setshowModal, customerId}) => {
  const [formData, setFormData] = useState([])
  const dispatch = useDispatch()

  const loadEmpOptions = (inputValue, callback) => {
    salesEmployeesByNameDebounce(inputValue, callback);
  };

  const handleSubmit = async (e) => {
    e.preventDefault()

    const data = []
    formData && formData.forEach((item) => data.push(item.label))

    try {
      await dispatch(assignContact({customerId, formData: { name: data} }));
      setshowModal(false)
    }
    catch(error) {
      toast.error(error.message)
    }
  }

  const handleCancel = () => {
    setshowModal(false)
  }

  return (
    <Modal
      show={showModal}
      onHide={() => setshowModal(false)}
      title="Assign responsible"
      backdropClick={false}
      footer={(
        <>
          <Button size="sm" type="submit" variant="primary" form="assign-customer-form"><FaUser /> Assign</Button>
          <Button size="sm" variant="danger" onClick={handleCancel}><FaBan /> Cancel</Button>
        </>
      )}
    >
      <form id="assign-customer-form" onSubmit={handleSubmit} className="tw-text-sm">
        <h6 className="tw-text-blue-600 tw-mb-2">Assign name secondary contact for this customer</h6>
        <Card bordered>
          <AsyncSelect
            cacheOptions
            defaultOptions
            loadOptions={loadEmpOptions}
            closeMenuOnSelect={false}
            placeholder='Select or input 3 characters of name...'
            classNamePrefix="react-select"
            className="tw-w-full"
            name="name"
            isMulti
            required
            onChange={setFormData}
          />
        </Card>
      </form>
    </Modal>
  )
};

AssignCustomerModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  customerId: PropTypes.number.isRequired
}

export default AssignCustomerModal;
